import React from 'react';
import { render } from 'react-dom';
import App from '../src/components/App';
import { getAppConfig } from './splunk-instrumentation';

// const globalFunctionName =
//   process.env.NODE_ENV === 'development'
//     ? process.env.REACT_APP_MFE_GLOBAL_FUNCTION_LOCAL
//     : process.env.REACT_APP_MFE_GLOBAL_FUNCTION;

// window[globalFunctionName] = containerId => {
//   render(<App />, document.getElementById(containerId));
// };
const voidSplunkData = { smso_rum_token: '', splunk_env: '' };
getAppConfig()
  .then(response => {
    console.log(`CEC Widget: Splunk RUM Data- ${response}`);
    render(<App splunkData={response} />, document.getElementById('root'));
  })
  .catch(error => {
    console.error(`CEC Widget: Unable to load Splunk RUM Data${error}`);
    render(<App splunkData={voidSplunkData} />, document.getElementById('root'));
  });
